import { render, staticRenderFns } from "./TeamInfoView.vue?vue&type=template&id=23bd9b6e&scoped=true&"
import script from "./TeamInfoView.vue?vue&type=script&lang=js&"
export * from "./TeamInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bd9b6e",
  null
  
)

export default component.exports